// extracted by mini-css-extract-plugin
export default {"postActionPage":"dwI48zTpAAJP2T5Y"};